/**
 * @platform web
 * @notice 全局自动缩放 — 小屏幕笔记本上等比缩小页面，接近 Ctrl+- 效果
 *
 * 原理：在 #app 容器上设置 CSS zoom，所有内容等比缩放
 * antd Portal 弹出层通过 ConfigProvider.getPopupContainer 强制挂载到 #app 内，保证定位一致
 * echarts 由 vue-echarts autoresize + ResizeObserver 自动处理
 *
 * Firefox 不支持 CSS zoom，自动跳过
 */
import { throttle } from '@sys/shared/utils';

const DESIGN_WIDTH = 1440;
const MIN_SCALE = 0.75;

let _currentScale = 1;

function _isFirefox() {
  return typeof navigator !== 'undefined' && /Firefox/i.test(navigator.userAgent);
}

function _calcScale() {
  const w = window.innerWidth;
  if (w >= DESIGN_WIDTH) return 1;
  return Math.max(MIN_SCALE, Math.round((w / DESIGN_WIDTH) * 100) / 100);
}

function _apply(factor) {
  const app = document.getElementById('app');
  if (!app) return;
  factor = Math.round(factor * 100) / 100;

  // 避免微小抖动反复设置
  if (factor === _currentScale) return;
  _currentScale = factor;

  if (factor >= 1) {
    app.style.zoom = '';
  } else {
    app.style.zoom = String(factor);
  }

  document.documentElement.style.setProperty('--global-scale', String(factor));
  document.documentElement.style.setProperty('--global-scale-inverse', String(1 / factor));
}

/**
 * 页面初始化时调用一次（main.js 中 mount 之前）
 * 窗口 resize 时自动重新计算
 */
export function applyGlobalScale() {
  if (_isFirefox()) return;

  _apply(_calcScale());

  // 窗口大小变化时自动调整
  window.addEventListener(
    'resize',
    throttle(() => _apply(_calcScale()), 200)
  );
}
